import { render, staticRenderFns } from "./menu_management.vue?vue&type=template&id=96f746a4&scoped=true"
import script from "./menu_management.vue?vue&type=script&lang=js"
export * from "./menu_management.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96f746a4",
  null
  
)

export default component.exports